import { LoadingOverlay } from '@eventbrite/eds-loading-overlay';
import React, { FunctionComponent } from 'react';

export const LoadingPage: FunctionComponent = () => (
    <LoadingOverlay isShown={true} />
);

export default LoadingPage;
